import { isNil } from 'lodash'
import { useFeature } from '@growthbook/growthbook-react'

export const useIsWorldCoinEnable = () => {
  return useFeature('yay-15517')?.on && !isNil(window?.gon?.WORLDCOIN_CLIENT_ID)
}
